var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFieldArea = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4.66667C4 4.29848 4.29848 4 4.66667 4H7.33333C7.70152 4 8 4.29848 8 4.66667V7.33333C8 7.70152 7.70152 8 7.33333 8H4.66667C4.29848 8 4 7.70152 4 7.33333V4.66667Z",
    fill: "#696F88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33333 0H2.66667V1.33333L9.33333 1.33333V0H10.6667V1.33333L12 1.33333V2.66667H10.6667V9.33333H12V10.6667H10.6667V12H9.33333V10.6667L2.66667 10.6667V12H1.33333V10.6667H0V9.33333H1.33333V2.66667H0V1.33333L1.33333 1.33333V0ZM2.66667 9.33333V2.66667H9.33333V9.33333L2.66667 9.33333Z",
    fill: "#696F88"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFieldArea);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/field_area.5666a4eb47ddb387f7523cb556f75e28.svg";